import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from 'src/environments/environment';

import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { BaseComponent } from '../../common/BaseComponent';
import { ProgressService } from 'src/app/service/ProgressService';
import { Constants } from 'src/app/util/Constants';
import { CommonService } from 'src/app/service/CommonService';

@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styles: [`
    .greyed-out {
      background-color: #ccc;
      /* Add any other styles to visually indicate the button is disabled */
    }`
  ]
})
export class OtpVerifyComponent extends BaseComponent implements OnInit {

  @ViewChild('oamOtpVerifyForm') oamOtpVerifyForm: ElementRef;
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;
  otpForm: FormGroup;
  user: User;
  sessionUser: string;
  restSub: Subscription;
  submitted = false;
  appErrorPrefix: string = "bss.api.error";
  oamSubmitUri = environment.getOamMfaAuthUri();
  resendDisabled: boolean = false;
  pageMsgRendered: boolean;
  getOtpClicked: boolean = false;

  constructor(
    injector: Injector,
    public progressService: ProgressService,
    public rest: UserService,
    public commonService: CommonService) {
    super(injector);
    this.menuService.setDisplayStatusByMenuType('secure');
    this.sessionUser = sessionStorage.getItem("user");
    this.pageMsgRendered = false;
  }

  ngOnInit(): void {
    this.otpForm = new FormGroup({
      pin: new FormControl(null, Validators.compose([Validators.required, Validators.pattern(Constants.P_NUMBERS_ONLY),
      Validators.minLength(8), Validators.maxLength(8)])),
      password: new FormControl(''),
      username: new FormControl(''),
      successurl: new FormControl('')
    });

    let resourceUrl: string = null;
    this.route.queryParams.subscribe(params => {
      const fullResourceUrl = decodeURIComponent((params['resource_url'])?.trim() ?? '');
      const clientID = (params['client_id'])?.trim() ?? '';

      // if resource url received then search of the resource_url within this string
      resourceUrl = CommonService.determineSigninUrl(fullResourceUrl);
      this.mapResourceURL(resourceUrl);
    });



    this.user = JSON.parse(this.sessionUser);
    console.log("Session User Details:" + JSON.stringify(this.user));
    let isPKIUser = JSON.parse(this.user.pkiuser);
    console.log("is pkiuser?:" + isPKIUser);

    if (isPKIUser) {
      this.checkRedirectUrl();
    } else if (!this.user.emailAccess) {
      this.router.navigate(['secure/user/reqemailupdate'])
    }
    this.getOTP();

  }

  getOTP(): void {
    this.getOtpClicked = true;
    this.rest.sendEmailMFA(this.user).subscribe(response => {
      console.log("otp-verify-send-email:" + JSON.stringify(response));
      if (response.result > 0) {
        this.appSuccess = false;
        this.appError = true;
        this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
      }
      // else {
      //   this.appError = false;
      //   this.appSuccess = true;
      //   this.appSuccessMessage = "bss.otpVerify.otp.sent.success";
      // }
    }, (error) => { this.processError(error) });

  }

  onSubmit(): void {
    console.log(this.oamOtpVerifyForm);
    this.submitted = true;
    this.appSuccess = false;
    this.appError = false;
    this.isSubmitting = false;
    this.pageMsgRendered = false;
    console.log('Entered OTP: ', this.otpForm.get('pin').value);


    if (this.otpForm.valid) {

      this.isSubmitting = true;
      this.user = JSON.parse(this.sessionUser);
      this.isSubmitting = true
      this.user.otp = this.otpForm.get("pin").value;

      this.progressService.open();

      // Verify whether OTP entered matches - 
      this.restSub = this.rest.validateEmailMFA(this.user).subscribe(response => {
        console.log("get-data:" + JSON.stringify(response));
        this.isSubmitting = false;
        if (response.result == 1) {
          this.appError = true;
          this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
        }
        else {
          this.appError = false;
          const password = response.emailOTPFlag;
          const username = response.username;
          this.otpForm.get("password").setValue(password);
          this.otpForm.get("username").setValue(username);
          console.log("emailOTPFlag:" + password + " - username:" + username);
          this.oamOtpVerifyForm.nativeElement.submit();
        }

      }, (error) => {
        this.processError(error);
      },
        () => {
          this.progressService.close();
        });
    }
  }

  onResend(): void {
    this.submitted = false;
    this.appSuccess = false;
    this.appError = false;
    this.resendDisabled = true;
    this.pageMsgRendered = false;
    //console.log(this.otpForm);
    //this.otpForm.setValue({ pin: '' });
    this.progressService.open();
    console.log('OTP Verify:: Resend OTP for user: ', this.user);
    this.restSub = this.rest.sendEmailMFA(this.user).subscribe(response => {
      console.log("send-email:" + JSON.stringify(response));
      if (response.result > 0) {
        this.appError = true;
        this.appSuccess = false;
        this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
      } else {
        this.appError = false;
        this.appSuccess = true;
        this.appSuccessMessage = this.getMessage("bss.otpVerify.otp.sent.success");
      }
    }, (error) => {
      this.processError(error);
    },
      () => {
        this.progressService.close();
      }
    );

    setTimeout(() => {
      this.resendDisabled = false;
    }, 60000);

    console.log('OTP Verify:: OTP sent for user: ', this.user);

  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }

  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }

  // make an api call to retrieve the mfa url
  mapResourceURL(signinURL: string) {
    if (signinURL) {
      signinURL = decodeURIComponent(signinURL);
      this.commonService.getURL(signinURL).subscribe(response => {
        console.log("get-sigin-url:" + JSON.stringify(response));
        let resourceUrl: string = null;
        if (response.result == 1) {
          console.log("Received an error:" + response.errorCode);
        } else {
          resourceUrl = response.usermfaURL;
          console.log("Mapping resourceUrl:" + resourceUrl);
          if (!resourceUrl.includes('/opsbpssecure/secure')) {
            this.contactService.setDisplayStatusByPageType('login');
          } else {
            this.contactService.setDisplayStatusByPageType('opsbps');
          }
          sessionStorage.setItem("resource_url", resourceUrl);
          this.otpForm.get("successurl").setValue(resourceUrl);
        }
      });
    }
  }

}